// extracted by mini-css-extract-plugin
export default {"userBox":"news_userBox__LkNRn","paramsBox":"news_paramsBox__NHYhO","btnBox":"news_btnBox__c+-td","desBox":"news_desBox__qfVqJ"};